export const AUTH_ENDPOINTS = {
  LOGIN: '/api/v1/auth/login',
  REFRESH: '/api/v1/auth/refresh',
  LOGOUT: '/api/v1/auth/logout',
  ME: '/api/v1/auth/me',
  CAMBIAR_PASSWORD: '/api/v1/auth/cambiar-password',
  SWITCH_APP: '/api/v1/auth/switch-app',
} as const;
